export const nonNull = (obj: any): boolean => {
  return obj !== null && obj !== undefined;
};

export const convertObjectToQueryString = (params: { [key: string]: string }) => {
  return Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');
};
